<template>
  <router-view />
  <Snackbar />
</template>

<script setup>
import Snackbar from "./components/base/SnackbarComponent.vue";
</script>
